"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGO_CLASS = exports.IMAGE_CLASS = exports.FILE_TYPES_TO_MIMES = exports.DEFAULT_MIN_BYTES = exports.DEFAULT_MAX_BYTES = exports.DEFAULT_ACCEPTABLE_FILE_TYPES = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
const IMAGE_CLASS = (0, _lodestarUtils.genId)("sds-image-uploader");
exports.IMAGE_CLASS = IMAGE_CLASS;
const LOGO_CLASS = (0, _lodestarUtils.genId)("sds-logo-uploader");
exports.LOGO_CLASS = LOGO_CLASS;
const FILE_TYPES_TO_MIMES = {
  PNG: "image/png",
  GIF: "image/gif",
  SVG: "image/svg+xml",
  JPG: "image/jpeg"
};
exports.FILE_TYPES_TO_MIMES = FILE_TYPES_TO_MIMES;
const DEFAULT_ACCEPTABLE_FILE_TYPES = ["PNG", "GIF", "JPG"];
exports.DEFAULT_ACCEPTABLE_FILE_TYPES = DEFAULT_ACCEPTABLE_FILE_TYPES;
const DEFAULT_MAX_BYTES = 1024 * 1024 * 5;
exports.DEFAULT_MAX_BYTES = DEFAULT_MAX_BYTES;
const DEFAULT_MIN_BYTES = 0;

// moved to imageUploaderTheme.ts
// export const IMAGE_DROPZONE_HEIGHT = 160;
// export const LOGO_DROPZONE_HEIGHT = 40;
// export const LARGE_LOGO_DROPZONE_HEIGHT = 52;
exports.DEFAULT_MIN_BYTES = DEFAULT_MIN_BYTES;
//# sourceMappingURL=constants.js.map